import convert from 'convert-units';

const formatDistance = (distanceInMeters: number, distanceUnit: string) => {
  if (distanceUnit === 'mi') {
    return `${convert(distanceInMeters).from('m').to('mi').toFixed(1)} mi`;
  }

  const { val, unit } = convert(distanceInMeters).from('m').toBest();
  return `${val.toFixed(1)} ${unit}`;
};

export default formatDistance;
